"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyError = /** @class */ (function (_super) {
    __extends(CurrencyError, _super);
    function CurrencyError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurrencyError;
}(Error));
exports.CurrencyError = CurrencyError;
exports.formatCurrency = function (pence) {
    var pounds, result;
    if (typeof pence === 'string') {
        pence = Number(pence);
    }
    if (typeof pence !== 'number') {
        throw new CurrencyError("Invalid currency format, expected number got " + typeof pence);
    }
    pounds = pence / 100;
    if (pounds === Math.round(pounds)) {
        result = pounds.toFixed(0);
    }
    else {
        result = pounds.toFixed(2);
    }
    if (result.indexOf('e') !== -1) {
        throw new CurrencyError('Currency value too long to display');
    }
    return result;
};
